export const GET_COUNTRIES = 'GET_COUNTRIES';
export const REQUEST_LOADING = 'REQUEST_LOADING';
export const GET_COUNTRY_DETAIL_SUCCESS = 'GET_COUNTRY_DETAIL_SUCCESS';
export const CLEAR_COUNTRY_DETAIL = 'CLEAR_COUNTRY_DETAIL';
export const SEARCH_COUNTRIES_REQUEST = 'SEARCH_COUNTRIES_REQUEST';
export const SEARCH_COUNTRIES_SUCCESS = 'SEARCH_COUNTRIES_SUCCESS';
export const ORDER_COUNTRIES = 'ORDER_COUNTRIES';
export const ORDER_FILTERED_COUNTRIES = 'ORDER_FILTERED_COUNTRIES';
export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const POST_ACTIVITY = 'POST_ACTIVITIES';
export const FILTER_ACTIVITIES = 'FILTER_ACTIVITIES';
export const REMOVE_ACTIVITY = 'REMOVE_ACTIVITY';
// export const URL_COUNTRIES = 'http://localhost:3001';
// export const URL_COUNTRIES_SEARCH_COUNTRY = 'http://localhost:3001/countries/search/country?name=';
// export const URL_COUNTRY = 'http://localhost:3001/country/';
// export const URL_ORDER = 'http://localhost:3001/countries/order';
// export const URL_POST_ACTIVITY = 'http://localhost:3001/activity';
// export const URL_GET_ACTIVITIES = 'http://localhost:3001/activity';
// export const URL_FILTER_ORDER_COUNTRIES = 'http://localhost:3001/countries/region';
// export const URL_REMOVE_ACTIVITY = 'http://localhost:3001/activity';
